import React, { useState } from 'react';
import CheckAuth from '../../elements/checkAuth';
import '../../../../styles/table.admin.css';
import styles from './nftInfo.module.css';
import Menu from '../../elements/Menu/menu';
import axios from 'axios';
import config from '../../../../config/environment';
import textStyles from './textStyle.module.css';
import './testStyles.css'
import NftsForm from './nftForm';
import ModalWindow from '../../elements/ModalWindow/modal';


let TableComponent = (props) =>{
    const { data, pages, showModal } = props
    const bufMap = []

    for (let key in data.records[0]) {
        bufMap.push(
            <th key = {key}>
                {key}
            </th>
        )
    }

    const iterObj = (object) =>{
        let i = 0;
        let bufMap = [];
        for (let key in object) {
            if (i !== 0){
                bufMap.push(
                    <td key = {key} >
                        {object[key]}
                    </td>
                )
            } else {
                bufMap.push(
                    <td key = {key} className='tableShowModal' onClick={showModal}>
                        {object[key]}
                    </td>
                );
                i++;
            }
        }

        return bufMap.map(el => el)
    };

    return(
        <>
            <div className={textStyles.heading}>
                Всего: {data.pages} страниц
            </div>
            <div className={textStyles.heading}>
                Текущая страница: {pages}, записей на странице: {data.records.length}
            </div>
            <table className="table tableInfoAddress">
                <thead>
                    <tr>
                        {
                            bufMap.map(el => el)
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        data.records.map((tx, index) => {
                            return (
                                <tr key={index}>
                                {
                                    iterObj(tx)
                                }
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </>
    )
};

export default function NftInfo () {
    let PAGE = 1;
    let ROW_DATA = {};

    const querryPrepare = (state) => {
        let tmp = "";
        let start = true
        for (const [key, value] of Object.entries(state)) {
            if (value) {
                if (start) {
                    tmp += `${key}=${value}&`;
                } else {
                    tmp += `${key}=${value}`;
                    start = false
                }
            }
        }
        return tmp;
    };

    const [state, setSelectNetworkState] = useState({
        page: 1,
        contractAddress: '',
        currencyCode: ''
    });

    const updateSelectValue = (event) => {
        setSelectNetworkState({
            ...state,
            currencyCode: event.target.value
        })
        setErrorState({
            ...errorState,
            currencyCodeError: false
        });
    };

    const updateInpConValue = (event) => {
        setSelectNetworkState({
            ...state,
            contractAddress: event.target.value
        });
        setErrorState({
            ...errorState,
            contractAddressError: false
        });
    };

    const updateInpPageValue = (event) => {
        setSelectNetworkState({
            ...state,
            page: event.target.value
        });
        setErrorState({
            ...errorState,
            pageError: false
        });
    };

    const [errorState, setErrorState] = useState({
        pageError: false,
        contractAddressError: false,
        currencyCodeError: false,
        showTable: false,
        data: null,
        textButton: "Submit",
        showModal: false,
        modalContractText: '',
        rowData: ""
    });

    const getInfo = async () =>{
        setErrorState({
            ...errorState,
            textButton:"Submit"
        })
        if (state.currencyCode === "DEFAULT" || !state.currencyCode) {
            setErrorState({
                ...errorState,
                currencyCodeError: true
            })
            return
        }
        
        if (!state.contractAddress.match("0x") && state.contractAddress !== "") {
            setErrorState({
                ...errorState,
                contractAddressError: true
            })
            return
        }

        if (state.page === "") {
            setSelectNetworkState({
                ...state,
                page: 1
            })
        }

        if (!Number(state.page) && state.page !== "") {
            setErrorState({
                ...errorState,
                pageError: true
            })
            return
        }
        setErrorState({
            ...errorState,
            textButton: "Wait..."
        })

        try {
            PAGE = state.page
            let querry = config.backendUrl + "/micro-trustee/get-contract-info?" + querryPrepare(state)
            await axios.get(querry, {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
                }
            }).then(
                (resp) => {
                    setErrorState({
                        ...errorState,
                        showTable: true,
                        data: resp.data,
                        textButton: 'Submit'
                    })
                }
            ).catch((error) => {
                alert(error.response.data.message)
                setErrorState({
                    ...errorState,
                    textButton: "Submit"
                })
            })
        } catch (error) {
            alert(error.response.data.message)
            setErrorState({
                ...errorState,
                textButton: "Submit"
            })
        }
    };

    const changeContract = () => {
        setErrorState({
            ...errorState,
            showModal: !errorState.showModal
        })
    }

    const showModal = () =>{
        setErrorState({
            ...errorState,
            showModal: !errorState.showModal
        })
    }

    const showModalWithText = (e) =>{
        ROW_DATA = errorState.data.records.filter((elem)=>{return elem.contractAddress === e.currentTarget.textContent })[0];
        setErrorState({
            ...errorState,
            showModal: !errorState.showModal,
            modalContractText: e.currentTarget.textContent,
            rowData: ROW_DATA
        })
    };

    return(
        <>
            <CheckAuth />
            <Menu />
            <div className={styles.wrapper}>
                <div className={styles.select_network}>
                    <div className={styles.select_network_wrap}>
                        <select onChange={updateSelectValue} style={errorState.currencyCodeError ? {border: "3px solid red"} : {border: "1px solid #1F082B"}} className={styles.select_network_item}>
                            <option value="DEFAULT">Select the network</option>
                            <option value="BNB">BNB</option>
                            <option value="MATIC">MATIC</option>
                            <option value="ONE">ONE</option>
                        </select>
                        <input className={styles.input_select_network} style={errorState.contractAddressError ? {border: "3px solid red"} : {border: "1px solid #1F082B"}} onChange={updateInpConValue} type="text" placeholder='Contract address (optional)'/>
                        <input className={styles.input_select_network_page} style={errorState.pageError ? {border: "3px solid red"} : {border: "1px solid #1F082B"}} onChange={updateInpPageValue} type="text" placeholder='page'/>
                    </div>
                    <button className={styles.submit_btn} onClick={getInfo} type='submit'>{errorState.textButton}</button>
                    <button className={styles.submit_btn_contract} onClick={changeContract} type='submit'>Change contract</button>
                </div>
                   <div className="history__table_wrapper_my">
                   {
                    errorState.showTable ? <TableComponent data = {errorState.data} pages = {PAGE} showModal={showModalWithText}/> : null
                   }
                </div>
                {
                    <ModalWindow show={ errorState.showModal }  close={ showModal } headerText={`Contract address: ${errorState.modalContractText ? errorState.modalContractText : ""} `}>
                        <NftsForm textCont={errorState.modalContractText} curCode={state.currencyCode} updateTable={getInfo} val1={errorState.rowData.contractName} val2={errorState.rowData.contractSymbol} val3={errorState.rowData.contractImage} val4={errorState.rowData.contractDescription}/>
                    </ModalWindow>
                }
            </div>
        </>
    );
};
